import {Injectable} from '@angular/core';
import { Platform } from 'ionic-angular';

/***
 *  设备类型，是否是 PC, MOBILE, IOS, ANDROID, mobileweb, IPAD等
 */
@Injectable()
export class MachineType {

  constructor(public platform: Platform) {
  }
  /***
   * 判断是否 IOS
   */
  isIos(): boolean{
  	return this.platform.is('ios');
  } 
  /***
   * 判断是否 ANDROID
   */
  isAndroid(): boolean{
  	return this.platform.is('android');
  }
  /***
   * 判断是否 Mobile  手机
   */
  isMobile(): boolean{
  	return this.platform.is('mobile');
  } 
  /***
   * 判断是否 MobileWeb  手机浏览器
   */
  isMobileWeb(): boolean{
  	return this.platform.is('mobileweb');
  }
  /***
   * 判断是否 cordova  设备上使用
   */
  isCordova(): boolean{
  	return this.platform.is('cordova');
  } 
  /***
   * 判断是否 ipad  设备上使用
   */
  isIpad(): boolean{
  	return this.platform.is('ipad');
  } 
  /***
   * 判断是否 iphone  设备上使用  
   */
  isIphone(): boolean{
  	return this.platform.is('iphone');
  }
  /***
   * 判断是否 tablet  设备上使用   平板电脑
   */
  isTablet(): boolean{
  	return this.platform.is('tablet');
  }
  /***
   * 判断是否 windows  设备上使用 
   */
  isWindows(): boolean{
  	return this.platform.is('windows');
  }
  
  
  
  
  

}



// WEBPACK FOOTER //
// ./src/providers/util/machine.ts